import { css } from 'styled-components';
import { grid } from '../../theme/utils/grid/grid';
import { SpacingName, getSpacing, getTypography, TypographyName, FontWeight } from '../../theme';
export const base = _ref => {
  let {
    theme
  } = _ref;
  return css(["", " flex-basis:100%;width:100%;"], getSpacing.paddingBottom(theme, SpacingName.SMALL));
};
export const content = _ref2 => {
  let {
    theme
  } = _ref2;
  return css(["", ""], grid(theme));
};
export const legend = _ref3 => {
  let {
    theme
  } = _ref3;
  return css(["", " ", " font-weight:", ";color:", ";display:flex;align-items:center;flex-shrink:0;width:100%;&::after{content:'';height:2px;display:block;background-color:", ";flex-grow:1;margin-left:1rem;}"], getTypography(theme, TypographyName.BODY), getSpacing.padding(theme, [SpacingName.SMALL, SpacingName.SMALLEST, 0]), FontWeight.BOLD, theme.palettes.neutrals.medium, theme.palettes.neutrals.light);
};
//# sourceMappingURL=Fieldset.style.js.map